































import { Vue, Component } from 'vue-property-decorator'
import Link, { emptyLink } from '@/models/Link'
import SubscriptionApi from '@/api/SubscriptionApi'

const messages = {
  loading: 'Just a sec...',
  error: 'There was a problem reading your link :(',
  unauthorized: "That link doesn't work :(",
  success: "You're in!"
}

@Component
export default class Director extends Vue {
  // flags
  private loading: boolean = false
  private error: boolean = false

  // data
  private token: string = ''
  private link: Link = emptyLink()
  private message: string = messages.loading

  created () {
    this.token = this.$route.params.token

    this.readSubscription()
  }

  // methods

  async readSubscription () {
    this.loading = true

    try {
      const response = await SubscriptionApi.access(this.token)

      this.message = messages.success
      this.link = response.link

      // TODO standardize to bus or service
      // remember token
      localStorage.setItem('emailToken', this.token)
    } catch (e) {
      this.error = true
      this.message = e.status === 401
        ? messages.unauthorized
        : messages.error

      console.error('Read Subscription error: ', e)
    }

    this.loading = false
  }

  onBack () {
    localStorage.removeItem('emailToken')

    this.$router.push({ name: 'home' })
  }
}
